module.exports = __webpack_public_path__ + "static/wash-sale-graphic-mobile.4ebc0564.svg";